import { Col, Form, Select } from "antd";
import { DailyFinishingLinePlanContext } from "context/DailyFinishingLinePlanContext";
import { useContext } from "react";
import SubStyleFilterCol from "./SubStyleFilterCol";

const DailyFinishingLinePlanFilter = ({
  initialTableData,
  form,
  filterClearTrigger = 0,
}) => {
  const { options, onSearchStyle } = useContext(DailyFinishingLinePlanContext);

  return (
    <>
      {/* <Col span={6}>
        <Form.Item label="Buyer" name="buyer">
          <Select placeholder="Select Buyer" onChange={onChangeBuyer}>
            {options?.buyers?.map((buyer) => (
              <Select.Option key={buyer.value} value={buyer.value}>
                {buyer.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
      <Col span={6}>
        <Form.Item
          label="Line"
          name="line"
          // rules={[{ required: false, message: "Please select Line!" }]}
        >
          <Select size="small" allowClear placeholder="Select Line">
            {options.finishingLines?.map((line) => (
              <Select.Option key={line.value} value={line.value}>
                {line.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={6}>
        <Form.Item label="Style" name="style">
          <Select
            size="small"
            allowClear
            placeholder="Select Style"
            // onChange={() => {
            //   onChangeStyle();
            //   setIsFromFilter(true);
            // }}
            showSearch
            optionFilterProp="children"
            onSearch={onSearchStyle}
            // rules={[{ required: false, message: "Please select Line!" }]}
          >
            {options?.styles?.map((style) => (
              <Select.Option key={style.value} value={style.value}>
                {style.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <SubStyleFilterCol
        filterClearTrigger={filterClearTrigger}
        styleFieldName="style"
        colSpan={6}
      />

      {/* <Col span={6}>
        <Form.Item
          label="PO"
          name="po_map_id"
          rules={[{ required: false, message: "Please select PO!" }]}
        >
          <Select placeholder="Select Style">
            {options?.po?.map((po) => (
              <Select.Option key={po.value} value={po.value}>
                {po.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
    </>
  );
};

export default DailyFinishingLinePlanFilter;
